const FONTS = {
    UbuntuBold: "UbuntuBold",
    UbuntuLight: "UbuntuLight",
    UbuntuMedium: "UbuntuMedium",
    UbuntuRegular: "UbuntuRegular",
  };
  
  export default FONTS;
  